var privacyCookieName = "cookie-privacy-consent"; // TODO: change this logic when iubenda is ready
var recentlyCookieName = "recently-products";

function setCookie(cname, cvalue, options) {
  var d = new Date();
  d.setTime(d.getTime() + options?.expires * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${cvalue};${expires};path=/;`;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const recentlyTileRender = function (product) {
  $(
    function ($) {
      var template = $("[data-recently-tile-template].hidden");
      var $container = $("#recently-viewed-container .products-grid__wrapper");
      var moneyFormat = theme.strings.moneyFormat;

      const row = template.clone(true);
      row.removeClass("hidden");
      row.removeAttr("data-recently-tile-template");

      row.find(".product-tile__container").attr("id", product.id);
      row.find("[data-title]").html(product.title);
      row.find("[data-url]").attr("href", product.handle);
      row.find("[data-vendor]").html(product.vendor);

      if (product.images[0]) {
        row.find("[data-img]").attr("src", product.images[0]);
        if (product.images[2]) {
          row.find("[data-img-hover]").attr("src", product.images[2]);
        } else if (product.images[1]) {
          row.find("[data-img-hover]").attr("src", product.images[1]);
        };
      } else {
        row.find("[data-img]").attr("src", window.pingInit.placeholderImageUrl);
        row.find("[data-img-hover]").remove();
        row.find("[data-img-change]").removeAttr("data-img-change");
      };
      const firstVariant = product.variants[0];
      const notSoldOut = product.available;

      if (
        firstVariant.compare_at_price !== 0 &&
        firstVariant.compare_at_price > firstVariant.price &&
        notSoldOut
      ) {
        const percentage = parseInt(
          (firstVariant.price * -100) / firstVariant.compare_at_price + 100
        );
        row
          .find("[data-compare-price]")
          .removeClass("hidden")
          .html(
            theme.Currency.formatMoney(
              firstVariant.compare_at_price,
              moneyFormat
            )
          );
        row
          .find("[data-price-percentage]")
          .removeClass("hidden")
          .html("(" + percentage + "%) ");
        row
          .find("[data-price]")
          .removeClass("hidden")
          .html(theme.Currency.formatMoney(firstVariant.price, moneyFormat));
      } else if (
        firstVariant.compare_at_price !== 0 &&
        firstVariant.compare_at_price > firstVariant.price
      ) {
        row
          .find("[data-price-sold-out]")
          .removeClass("hidden")
          .html(theme.Currency.formatMoney(firstVariant.compare_at_price, moneyFormat));
      } else {
        row
          .find("[data-price]")
          .removeClass("hidden")
          .html(theme.Currency.formatMoney(firstVariant.price, moneyFormat));
      }

      if (!notSoldOut) {
        row
          .find("[data-price-sold-out-label]")
          .addClass("active");
      }

      if (firstVariant.compare_at_price > firstVariant.price && notSoldOut) {
        row
          .find(".product-tile__absolutes__tags__tag--on-sale")
          .removeClass("hidden");
      }

      const tags = product.tags;
      const renderTags = tags.forEach((tag) => {
        if (tag.indexOf("LABEL_") > -1) {
          const tagText = tag.replace("LABEL_", "");
          let tagElement = `<span class="product-tile__absolutes__tags__tag product-tile__absolutes__tags__tag--${tagText}">${tagText}</span>`;
          row.find(".product-tile__absolutes__tags").append(tagElement);
        }
      });

      product.variants.forEach((variant) => {
        const url = product.handle + "?variant=" + variant.id;
        var href = `<a href="${url}" class="product-tile__images__hover__size">${variant.title}</a>`;
        if (!variant.available) {
          href = `<a href="${url}" class="product-tile__images__hover__size product-tile__images__hover__size--sold-out">${variant.title}</a>`;
        }
        row.find(".product-tile__images__hover").append(href);
      });

      $container.append(row);
    },
    [jQuery]
  );
};

async function getProductJSON(url) {
  const response = await fetch(url);
  const product = await response.json();
  return product;
}

document.addEventListener("DOMContentLoaded", async function () {
  var recentlyViewedContainer = document.getElementById(
    "recently-viewed-container"
  );

  if (!recentlyViewedContainer) {
    return;
  }

  var currentProductHandle = recentlyViewedContainer.querySelector(
    ".product-tile__container"
  ).dataset.currentProductHandle;

  if (!currentProductHandle.length > 0) {
    return;
  }

  setCookie(privacyCookieName, "1"); // TODO: change this logic when iubenda is ready

  if (getCookie(privacyCookieName) == "1") {
    // TODO: change this logic when iubenda is ready
    const recentlyViewed = getCookie(recentlyCookieName);
    const recentlyProducts =
      recentlyViewed.length > 0 ? JSON.parse(recentlyViewed) : [];
    if (!recentlyProducts.includes(currentProductHandle)) {
      recentlyProducts.unshift(currentProductHandle);
      setCookie(recentlyCookieName, JSON.stringify(recentlyProducts));
    }
  }

  const recentlyViewed = getCookie(recentlyCookieName);
  const handles = JSON.parse(recentlyViewed);

  const productPromises = handles.map((handle) => {
    const jurl = `${Shopify.routes.root}products/${handle}.js`;
    const url = `${Shopify.routes.root}products/${handle}.json`;

    return getProductJSON(jurl);
  });

  // this condition is necessary when the current product is the only one present in the cookie
  if (
    handles.length > 1 &&
    window.location.pathname.includes(currentProductHandle)
  ) {
    recentlyViewedContainer.classList.add("show");

    try {
      const products = await Promise.all(productPromises);
      products.forEach((product, index) => {
        if (
          index < 4 &&
          typeof product !== "undefined" &&
          typeof product.images !== "undefined"
        ) {
          recentlyTileRender(product);
        }
      });
    } catch (err) {
      console.error(err);
    }
  }
});
